import React from 'react';
import ReactQuill from 'react-quill';

class RichText extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: props.formData,
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      formData: nextProps.formData
    });
  }

  onChange(richText) {
    this.setState({
      formData: richText
    }, () => this.props.onChange(this.state.formData));
  }

  render() {
    const toolbar = [
      ['bold', 'italic', 'underline','strike'],
      [{'list': 'ordered'}, {'list': 'bullet'}],
      ['link'],
      ['clean']
    ];

    const formats = [
      'bold', 'italic', 'underline', 'strike',
      'list', 'bullet',
      'link',
    ];

    const modules = {
      toolbar,
    };

    return (
      <div>
        <label className="control-label">{ this.props.schema.title }</label>
        <ReactQuill onChange={this.onChange} value={ this.state.formData } modules={ modules } formats={ formats }/>
      </div>
    );
  }
}

export default RichText;